import { RecommendationRuleEffectName } from '@biteinc/enums';
import { AbstractModelSchema } from './abstract_model_schema.js';
export const recommendationRuleSchema = {
    displayName: 'recommendation rule',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        orgId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        siteId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        description: {
            type: 'shortString',
            required: true,
        },
        magicCopyKey: {
            type: 'keyString',
            isReadOnly: true,
            isHidden: true,
        },
        affinityRunId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        isInvalid: {
            type: 'bool',
            isReadOnly: true,
            isHidden: true,
        },
        invalidReason: {
            type: 'shortString',
            isReadOnly: true,
            isHidden: true,
        },
        conditionSchema: {
            type: 'object',
            isReadOnly: true,
            isHidden: true,
            isFreeform: true,
        },
        conditionTimingIds: {
            displayName: 'Condition Timings',
            type: 'array',
            elementType: 'mongoId',
            ui: 'table',
            placeholder: 'Select Timings',
            collapse: true,
        },
        recommendationEffect: {
            type: 'object',
            isReadOnly: true,
            isHidden: true,
            fields: {
                name: {
                    type: 'stringEnum',
                    enum: RecommendationRuleEffectName,
                },
                body: {
                    type: 'object',
                    allowEmpty: true,
                    conditions: [
                        {
                            field: 'name',
                            values: [
                                RecommendationRuleEffectName.DoNotRecommendItems,
                                RecommendationRuleEffectName.DoNotRecommendItemsInSection,
                                RecommendationRuleEffectName.HeuristicsV2,
                                RecommendationRuleEffectName.MenuItemAffinity,
                                RecommendationRuleEffectName.MenuItemAffinityMagicCopyKey,
                                RecommendationRuleEffectName.RecommendGuestFavoriteItems,
                                RecommendationRuleEffectName.RecommendGuestPredicationsOnPreviouslyOrderedItems,
                                RecommendationRuleEffectName.RecommendGuestPreviouslyOrderedItems,
                                RecommendationRuleEffectName.RecommendItems,
                                RecommendationRuleEffectName.RecommendItemsInSection,
                                RecommendationRuleEffectName.RecommendModifiers,
                                RecommendationRuleEffectName.SortItemsInSection,
                                RecommendationRuleEffectName.SortItemsInSectionsRandomly,
                            ],
                        },
                    ],
                    fields: {
                        sectionId: {
                            type: 'mongoId',
                        },
                        sectionIds: {
                            type: 'array',
                            elementType: 'mongoId',
                        },
                        itemIds: {
                            type: 'array',
                            elementType: 'mongoId',
                        },
                        modifierIds: {
                            type: 'array',
                            elementType: 'mongoId',
                        },
                        limitItemsAfterFiltering: {
                            type: 'int',
                        },
                        randomizeEffectItemIds: {
                            type: 'bool',
                        },
                        randomSortItemsWithinSections: {
                            type: 'bool',
                        },
                        formulaDescription: {
                            type: 'shortString',
                        },
                    },
                },
            },
        },
    },
};
//# sourceMappingURL=recommendation_rule_schema.js.map